import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '../../components/Typography';

const styles = theme => ({
  root: {
    backgroundColor: '#EEEFF0',
    border: '1px solid #e1e1e1',
    padding: '4rem 5rem',
    [theme.breakpoints.down('sm')]: {
      padding: '1rem 2rem',
      margin: '2rem auto'
    },
    [theme.breakpoints.down('xs')]: {
      padding: '1rem'
    },
    [theme.breakpoints.down('321')]: {
      padding: '2rem 1rem',
      margin: '1rem auto 0'
    }
  },
  text: {
    fontSize: '.8rem'
  }
});

class Disclosures extends React.Component {
  render() {
    // eslint-disable-next-line react/prop-types
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="body2" className={classes.text}>
          <b>DISCLOSURES: 1.)</b> Savings is calculated on retail pricing during
          February 2023 and is subject to change based on manufacturer pricing
          and promotions. In order to purchase products at the member price a
          consumer must first become a member of DirectBuy.
          <b> 2.)</b> DirectBuy members purchase products directly from the
          manufacturer OR authorized supplier.
        </Typography>
      </div>
    );
  }
}

export default withStyles(styles)(Disclosures);
